import PrivacyPolicyMDX from "../../docs/Privacy-Policy.md";

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <PrivacyPolicyMDX />
    </div>
  );
};

export default PrivacyPolicy;
